export default __webpack_public_path__ + "static/media/paw.3f9b389c.png";